import React from 'react';
import styled from 'styled-components';
import Logo from "../../../../assets/images/logos/highlights-logo.svg";

const Footer = styled.div`
  background-color: #FEFAE5;
  display: flex;
  flex-direction: column;
  padding: 6rem 2rem 3rem 2rem;
`;

const Subfooter = () => (
  <Footer>
    <div className="max-w-screen-lg mx-auto">
      <div className="flex flex-row items-center justify-center">
        <img src={Logo} alt="Highlights for Children" height="505" className="h-20" />
      </div>
      <div className="text-center my-8">
        <p className="max-w-xl text-lg text-tgnavy">
          Tinkergarten is now part of the <a href="https://shop.highlights.com" target="_blank" className="text-tgred">Highlights for Children</a> family. Together, we share an unwavering commitment to make a lasting, positive impact in the lives of children and families.
        </p>
      </div>
      <div className="flex justify-center my-8">
        <a className="btn btn-solid" href="/">Learn More About Tinkergarten</a>
      </div>
    </div>
  </Footer>
);

export default Subfooter;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Footers/Subfooter.jsx